/* eslint-disable no-magic-numbers */
import store from "@/store";
import { formatNumberWithComma } from "@/utils";

export default {
	myGoalsYouHaveSaved() {
		return {
			title: { display: false },
			legend: { display: false },
			tooltips: { callbacks: {} },
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				ticks: { min: 0 },
				xAxes: [
					{
						display: true,
						gridLines: {
							color: "rgba(200, 200, 200, 0)",
							lineWidth: 1,
							drawBorder: false,
							display: false,
						},
						ticks: {
							fontFamily: "Nunito Sans",
							fontColor: store.getters["branding/colors"][0],
						},
					},
				],
				yAxes: [
					{
						gridLines: {
							color: "rgba(200, 200, 200, 0.3)",
							lineWidth: 1,
							drawBorder: false,
							padding: "20px",
						},
						ticks: {
							maxTicksLimit: 6,
							fontColor: store.getters["branding/colors"][0],
							padding: 20,
							fontFamily: "Nunito Sans",
							min: 0,
						},
					},
				],
			},
		};
	},
	foodWasteChart() {
		return {
			title: { display: false },
			legend: { display: false },
			tooltips: {
				// Use comma formatting for all tooltips
				callbacks: {
					label: function (tooltipItem) {
						const currency = store.getters["user/activeOutlet"].currency;
						const value = Number(tooltipItem.value);
						return `${currency} ${formatNumberWithComma(value, 2)}`;
					},
				},
			},
			maintainAspectRatio: false,
			scales: {
				xAxes: [
					{
						gridLines: {
							drawBorder: false,
							display: false,
							color: "rgba(0, 0, 0, 0)",
						},
						ticks: {
							fontSize: 11,
							fontColor: store.getters["branding/colors"][0],
							fontFamily: "Nunito Sans",
							lineHeight: 1.3,
							precision: 0,
						},
					},
				],
				yAxes: [
					{
						gridLines: { drawBorder: false },
						ticks: {
							beginAtZero: true,
							padding: 10,
							fontSize: 11,
							maxTicksLimit: 6,
							fontColor: store.getters["branding/colors"][0],
							callback: (value) => {
								const currency = store.getters["user/activeOutlet"].currency;
								return `${currency} ${formatNumberWithComma(value)}`;
							},
						},
					},
				],
			},
		};
	},
};
